import { useEffect, useState } from 'react'
import { Fancybox, type FancyboxOptions } from '@fancyapps/ui/dist/fancybox/'
import posthog from 'posthog-js'

import '@fancyapps/ui/dist/fancybox/fancybox.css' // should be moved to global scope if needed by others

// only listing detail is using fancybox right now so there is no need to componentize it. if we need
// to use fancybox on somewhere else (city page or lakshmi) it'd be better to encapsulate/centralize to avoid repeating code
export default function useFancybox(options: Partial<FancyboxOptions> = {}) {
  const [root, setRoot] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (root) {
      const handleFancyboxInit = () => {
        posthog.capture('fancybox_modal_opened')
      }

      Fancybox.bind(root, '[data-fancybox]', {
        ...options,
        on: {
          init: handleFancyboxInit,
          ...options.on
        }
      })

      return () => Fancybox.unbind(root)
    }
  }, [root, options])

  return [setRoot]
}
